require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-not-for-profits-donor.json") })
        }
      }, "path---blog-not-for-profits-donor");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-not-for-profits-donor!./.cache/json/blog-not-for-profits-donor.json
// module id = 834
// module chunks = 231608221292675